import * as RadixTooltip from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';
import './Tooltip.css';

export interface TooltipProps {
  /** The label text shown in the tooltip. */
  content: ReactNode;
  /** The element that triggers the tooltip (hover/focus target). */
  children: ReactNode;
  /** Delay in ms before showing on hover. Default 300. */
  delayDuration?: number;
  /** Which side of the trigger to place the tooltip. */
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** Alignment along the chosen side. */
  align?: 'start' | 'center' | 'end';
}

/**
 * Tooltip — small dark pill on hover/focus. Wrap any element with it.
 * Built on Radix Tooltip → proper delay + focus accessibility + ESC support.
 * Mobile: Radix correctly skips hover opens on touch-only devices.
 */
export function Tooltip({ content, children, delayDuration = 300, side = 'top', align = 'center' }: TooltipProps) {
  return (
    <RadixTooltip.Provider delayDuration={delayDuration}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            className="fluent-tooltip-content"
            side={side}
            align={align}
            sideOffset={6}
          >
            {content}
            <RadixTooltip.Arrow className="fluent-tooltip-arrow" width={10} height={5} />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
